import { render } from "./KpsOfficersWorkView.vue?vue&type=template&id=6428213d&scoped=true"
import script from "./KpsOfficersWorkView.vue?vue&type=script&lang=js"
export * from "./KpsOfficersWorkView.vue?vue&type=script&lang=js"

import "./KpsOfficersWorkView.vue?vue&type=style&index=0&id=6428213d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6428213d"]])

export default __exports__